<template>
    <div class="home-default-comp">
        <div class="left">
            <div class="col2">
                <home-circle-chart-empty></home-circle-chart-empty>
                <home-circle-chart-kpi></home-circle-chart-kpi>
            </div>
            <todo-list></todo-list>
        </div>
        <div class="right">
            <home-bar-chart></home-bar-chart>
            <tools-list></tools-list>
        </div>
    </div>
</template>
<script>
import homeCircleChartEmpty from '@/components/bussiness/personalHome/home/chart/homeCircleChartEmpty.vue';
import homeCircleChartKpi from '@/components/bussiness/personalHome/home/chart/homeCircleChartKpi.vue';
import homeBarChart from '@/components/bussiness/personalHome/home/chart/homeBarChart.vue';
import todoList from '@/components/bussiness/personalHome/home/todoList/todoList.vue';
import toolsList from '@/components/bussiness/personalHome/home/toolsList/toolsList.vue';

export default {
    components: {
        homeCircleChartEmpty,
        homeCircleChartKpi,
        homeBarChart,
        todoList,
        toolsList
    }
}
</script>
<style lang="scss" scoped>
    .home-default-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .left{
            width: 700px;
            >div{
                margin-bottom: 20px;
            }
            .col2{
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
        .right{
            width: 420px;
            >div{
                margin-bottom: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/homeDefaultComp.vue